import { Container, makeStyles, Typography } from "@material-ui/core";
import { StyledFirebaseAuth } from "react-firebaseui";
import { firebaseAuth, googleProvider } from "../firebase/firebaseModel";
import { useDispatch, useSelector } from "react-redux";
import { loginAttemp, loginAttempError, loginAttempSuccess } from "../action/loginAction";
import defaultAva from "../img/defaultAvatar.png"
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import { getLink, isUserHaveStudent } from "../firebase/firebaseController";

const useStyles = makeStyles({
    container: {
        minHeight: "100vh",
        height: "fit-content",
        minWidth: "515px",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "50px 0px",
        gap: "10px"
    },
    error: {
        color: "red",
    },
    defaultAva: {
        width: "200px"
    }
});


export default function Login() {
    let classes = useStyles();
    let loginState = useSelector(state => state.userState);
    let dispatch = useDispatch();
    let history = useHistory();
    const uiConfig = {
        callbacks: {
            signInSuccessWithAuthResult: async function (authResult, redirectUrl) {
                var user = authResult.user;
                let newObj = {
                    name: user.displayName,
                    email: user.email,
                    image: user.photoURL
                }
                dispatch(loginAttemp());
                await new Promise(resolve => setTimeout(resolve, 2000));
                let link = await getLink(newObj.email.replace(".","_"));
                newObj["link"] = link;
               
                localStorage.setItem("UserLogin", JSON.stringify(newObj));
                let push;
                if(await isUserHaveStudent(newObj.email.replace(".","_"))){
                   push=()=> history.push("/dashboard");
                }
                else push=()=>history.push("/studentSubmission");
                dispatch(loginAttempSuccess(newObj))
                push();
                return false;
            },
            signInFailure: function (error) {

                dispatch(loginAttempError(error))
                return true;
            },
        },
        signInFlow: "popup",
        signInOptions: [googleProvider]
    }
    return (
        <>
            {!loginState.loading &&
                <Container className={classes.container} fixed>
                    <Typography variant="h2" >
                        Answer Port
                    </Typography>
                    <Typography variant="h6" >
                        Welcome. Please Sign In.
                    </Typography>
                    <img src={defaultAva} className={classes.defaultAva} alt="default avatar" />
                    <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebaseAuth} />
                    <Typography variant="subtitle1" className={classes.error}>
                        {loginState.error}
                    </Typography>
                </Container>
            }
            {loginState.loading &&
                <Loading />
            }
        </>
    )
}


